import {Utils} from 'components/shared';

var keyModifier = Utils.getKeyModifier();

var defaultKeymap = {
    ArrOutputDetail: {},
};

export default defaultKeymap;
